// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        require: {
            datepicker: {
                url: '//cdn.jsdelivr.net/npm/litepicker/dist/litepicker.js',
                fallback: '//cdn.jsdelivr.net/npm/litepicker/dist/litepicker.js',
                callback: null
            },
            sortable: {
                url: '//code.jquery.com/ui/1.12.1/jquery-ui.js',
                fallback: '//code.jquery.com/ui/1.12.1/jquery-ui.js',
                callback: null
            },
            html2canvas:{
                url: '//html2canvas.hertzen.com/dist/html2canvas.min.js',////cdnjs.cloudflare.com/ajax/libs/html2canvas/0.5.0-beta4/html2canvas.min.js',
                fallback: '//html2canvas.hertzen.com/dist/html2canvas.min.js',////cdnjs.cloudflare.com/ajax/libs/html2canvas/0.5.0-beta4/html2canvas.min.js',
                callback: null
            }
        },
        ecom: {
            booth: {
                url: '/system/data/booth'
            },
            catering: {
                url: '/system/data/catering'
            },
            parts: {
                url: '/system/data/parts'
            },
            cart: {
                url: '/system/data/cart'
            }
        }
    } );
}() );
